module.exports = __webpack_public_path__ + "static/bluestarblanket-5460e60ab1952424a792ddd1b8b5ee15.jpeg";